import React, { Fragment } from 'react';
import MediaQuery from 'react-responsive';
import Avatar from 'react-avatar';
import {
    Dropdown, DropdownToggle, DropdownMenu, DropdownItem, NavLink, Navbar, NavbarBrand, NavItem, NavbarToggler, Collapse, Row, Col, Container
} from 'reactstrap';
import LoginMenu from './loginMenu';
import GiNavToggler from './GiNavToggler';
import ColorSignUpButton from './colorSignUpButton';
import GiveIndia from '../../elements/icons/giveIndia';
import { subscribe } from 'react-contextual';
import getConfig from 'next/config';
import COLORS from '../../../../common/colors';
import SignoutButton from './signoutButton';
import Cookie from '../../../../util/cookies';
import cookies from '../../../../util/cookies';
import QuickSearch from '../../../search/quickSearch';
import SelectByPlatform from '../../../workplace/common/selectByPlatform';
import PartnerLogo from "../../../workplace/common/partnerLogo";
import WGNavToggler from "../../../workplace/WGHeader/WGNavToggler";
import RequestInfoContext from '../../../common/requestInfoContext';
import SearchIcon from '../../elements/icons/searchIcon';
import { BurgerNav } from '../../elements/icons/burgerNav';
import Cancel from '../../elements/icons/cancel';
import { BurgerNavMenu } from './burgerNavMenu';
import ColorLoginUpButton from './colorLoginButton';

const config = getConfig().publicRuntimeConfig;

let secondaryMenuPosition;
const defaultNavHeight = '90px';

class Header extends React.Component {
    constructor(props) {
        super(props);
        let firstName = '';
        let lastName = '';
        let name = null;
        let socialLoginJson = {};
        if (this.props.session && this.props.session.user) {
            if (this.props.session.user.firstName && this.props.session.user.firstName !== null) {
                firstName = this.props.session.user.firstName;
            }
            if (this.props.session.user.lastName && this.props.session.user.lastName !== null) {
                lastName = this.props.session.user.lastName;
            }
            if (firstName !== '' || lastName !== '') {
                name = `${firstName} ${lastName}`;
            }

            const { socialLogins } = this.props.session.user;
            if (typeof socialLogins !== 'undefined') {
                socialLogins.forEach((socialLogin) => {
                    socialLoginJson[socialLogin.type] = socialLogin.loginId;
                });
            }
        }
        // this.toggleNavbar = this.toggleNavbar.bind(this);
        this.state = {
            isOpen: false,
            dropdownOpen: false,
            name: name || this.props.session.user && this.props.session.user.email,
            socialLogins: socialLoginJson,
            hasUpdateSeen: false,
            toggleSearchBox: false,
            searchTags: [],
            headerTopMargin: null,
            missionsDropdownOpen: false,
            getInvolved: false
        };

        this.trackCauseClick = this.trackCauseClick.bind(this);
    }

    UNSAFE_componentWillMount() {
        if (window) {
            if (cookies.read('updates_seen')) {
                this.setState({
                    hasUpdateSeen: true
                })
            }
        }
    }

    componentDidMount() {
        let headerElement = document.getElementById('secondary-menu-sticky');
        if (!this.props.hideSearch && headerElement) {
            const headerTopMargin = headerElement.offsetTop;
            this.setState({
                headerTopMargin
            })
            window.addEventListener('scroll', this.handleScroll);
        }
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.handleScroll);
    }

    handleScroll = () => {
        secondaryMenuPosition = this.state.headerTopMargin;
        let scrollDistance = document.documentElement.scrollTop;
        let element = document.getElementById('secondary-menu-sticky');

        if (element) {
            if (scrollDistance >= this.state.headerTopMargin) {
                element.style.position = "fixed";
                element.style.top = 0;
                element.style.left = 0;
            }
            else {
                element.style.position = "relative";
                element.style.top = null;
                element.style.left = null;
            }
        }
    }

    toggleNavbar = () => {
        this.setState({
            isOpen: !this.state.isOpen,
        });
    }

    registerSearchClick = () => {
        window.location.href = `/search`;
    }

    trackCauseClick(event) {
        try {
            const eventInfo = { cause: event.target.textContent.trim() };
            if (window.eventDispatcher) {
                window.eventDispatcher.dispatchEventSync('stickyheader_cause_click', eventInfo, { amplitude: true });
            }
        }
        catch (e) {
            console.log("error tracking cause pill click", e);
        }

        return true;
    }

    toggle = () => {
        this.setState({
            dropdownOpen: !this.state.dropdownOpen,
        });
    }

    toggleMissions = () => {
        this.setState({
            missionsDropdownOpen: !this.state.missionsDropdownOpen
        })
    }

    toggleGetInvolved = () => {
        this.setState({getInvolved: !this.state.getInvolved})
    }

    updateClicked = (e) => {
        e.preventDefault();
        Cookie.save('updates_seen', true);
        window.location.href = `/user/reports`
    }

    toggleSearchBox = (e) => {
        e.preventDefault();
        this.setState({
            toggleSearchBox: !this.state.toggleSearchBox
        })
    }

    clickMission = (link) => {
        const eventInfo = { mission: link.heading };
        if (window.eventDispatcher) {
            window.eventDispatcher.dispatchEventSync(`Menu Mission`, eventInfo, { amplitude: true });
        }
    }

    render() {

        const {
            logo, toggleLogInModal, toggleSignUpModal, backgroundColor, session, canonicalUrl,
            stickyTop, fixedTop, navHeight, color, width, hideSearch, tenantConfig, subdomain,
            loginBackgroundColor, hideOldPlatformLink, hideMainMenu
        } = this.props;
        const classname = this.state.dropdownOpen ? 'show' : '';
        const { facebook, google } = this.state.socialLogins;

        const firstNameColor = backgroundColor === "transparent" ? "white" : "black";
        const ifBorderStyle = { borderBottom: "none !important" }
        const elseBorderStyle = { borderBottom: "1px solid rgba(0, 0, 0, 0.1)" }
        const tenantName =  tenantConfig.name.short

        return (

            <Navbar className={`wg-header page-header navbar-expand-md ${stickyTop ? 'sticky-top' : ''} ${fixedTop ? 'fixed-top' : ''}`} light style={{ ...backgroundColor ? { backgroundColor } : null, minHeight: navHeight || defaultNavHeight, zIndex: 150 }}>
                <MediaQuery minWidth={992} device={{ width }}>

                    <div className="header-container container-fluid p-0" style={backgroundColor === "transparent" ? ifBorderStyle : elseBorderStyle}>
                        <Row className="w-100">
                            <div className="primary-navbar-submenu navbar-right d-flex  navbar-nav w-100 px-0 pd-0" style={backgroundColor === "transparent" ? ifBorderStyle : elseBorderStyle}>
                            {session && session.user ? <Col className='navbar-submenu-link-login d-flex w-100 navbar-brand-logo' name={"www"}>
                                    <NavbarBrand href="/">
                                        <SelectByPlatform>
                                            <GiveIndia name={"www"} width="125" color={!logo || logo === '' || logo === 'color' ? '' : logo} />
                                            <span></span>
                                        </SelectByPlatform>
                                    </NavbarBrand>
                                </Col>: null }
                                {session && session.user ? <Col md={8} className="navbar-submenu-link d-flex w-100" style={{ alignItems: 'center' }}>
                                <Col md={8} className='navbar-submenu-link-login d-flex w-100 px-0' name={"www"}>
                                    <Fragment>
                                        <NavLink className="user-nav-link" style={{ color: color ? color : "#444444" }} href={`${config.fundraisersPlatformUrl}`} target="_blank">
                                        GiveIndia Fundraisers
                                        </NavLink>

                                        <NavLink className="user-nav-link" style={{ color: color ? color : "#444444" }} href='https://workplace.giveindia.org/' target="_blank">
                                            Workplace Giving
                                        </NavLink>

                                        {/* <NavLink className="user-nav-link" style={{ color: color ? color : "#444444" }} href={'#'} target="_blank">
                                            Our Work
                                        </NavLink> */}

                                        <NavLink className="user-nav-link" style={{ color: color ? color : "#444444" }} href={'/aboutus'} target="_blank">
                                            About Us
                                        </NavLink>

                                        {/* <Dropdown isOpen={this.state.getInvolved} toggle={this.toggleGetInvolved} className="user-nav-link user-dropdown-menu submenu-dropdown p-0 no-wrap">
                                            <DropdownToggle nav caret style={{ color: color ? color : "#444444" }} >
                                                Get Involved
                                                </DropdownToggle>
                                            <DropdownMenu>
                                            <NavLink className="user-nav-link" style={{ color: color ? color : "#444444" }}  href='https://www.giveindia.org/giveassured' target="_blank">
                                                Corporate Partnerships
                                            </NavLink>
                                            <NavLink className="user-nav-link" style={{ color: color ? color : "#444444" }} rel="noopener noreferrer" target="_blank" href='https://workplace.giveindia.org/'>
                                                Workplace Giving
                                            </NavLink>
                                            </DropdownMenu>
                                        </Dropdown> */}
                                    
                                    </Fragment>
                                </Col>

                                    {session.user.hasDonated && session.user.hasBeneficiaryAssigned && <NavLink className="user-nav-link" style={{ color: color ? color : "#444444", whiteSpace: 'nowrap', cursor: "pointer" }} onClick={(e) => this.updateClicked(e)} target="_blank">
                                        Updates
										{!this.state.hasUpdateSeen && session.user.updates.count > 0 && <span className="notification-alert badge alert">{this.props.session.user.updates.count}</span>}
                                    </NavLink>
                                    }
                                    {session.user.hasDonated && <span className="secondary-header-spacer d-flex align-items-center ml-2 mr-0" style={{ color: "rgba(0, 0, 0, 0.3)", fontSize: '20px' }}>|</span>}
                                    {session.user.firstName && <span className="user-salutation-text ml-2" style={{ fontSize: "14px", marginRight: "-0.5rem", textTransform: "capitalize", cursor: "pointer", color: `${firstNameColor}` }} onClick={this.toggle}>Hello, {session.user.firstName}</span>}
                                    <Dropdown isOpen={this.state.dropdownOpen} toggle={this.toggle} className="user-nav-link user-dropdown-menu p-0 no-wrap" >
                                        <DropdownToggle nav caret style={{ color, paddingTop: '0.25rem' }}>
                                            {/* if you want to chnge the line height of avatar initials chang it in class sb-avatar */}
                                            <Avatar
                                                round
                                                textSizeRatio={1.5}
                                                size="25"
                                                maxInitials={2}
                                                facebookId={facebook}
                                                googleId={google}
                                                name={this.state.name}
                                                className="sb-avatar avatar-wrapper-new"
                                            />
                                        </DropdownToggle>
                                        <DropdownMenu
                                            className={classname}
                                            style={{
                                                width: '100%',
                                                padding: '1rem',
                                                boxShadow: '0 0 5px rgba(0, 0, 0, 0.1) !important',
                                                borderRadius: '2px',
                                                border: '1px solid #DBDBDB !important',
                                                margin: '-3rem 0 0 -3rem',
                                                right: '0',
                                            }}
                                        >
                                            <a className="dark-no-hover-a no-color" href="/user/profile" style={{ color: COLORS.giveDarkGrey }} >
                                                <DropdownItem toggle={false} style={{
                                                    textAlign: 'left', padding: '0.8rem', cursor: 'pointer', borderBottom: '1px solid rgba(0,0,0,0.1)', color: COLORS.giveDarkGrey,
                                                }}
                                                >
                                                    Your Profile
										</DropdownItem>
                                            </a>
                                            {this.props.session.user.role === 'editor' && <a className="dark-no-hover-a no-color" href="/admin-dashboard" style={{ color: COLORS.giveDarkGrey }} >
                                                <DropdownItem toggle={false} style={{
                                                    textAlign: 'left', padding: '0.8rem', cursor: 'pointer', borderBottom: '1px solid rgba(0,0,0,0.1)', color: COLORS.giveDarkGrey,
                                                }}
                                                >
                                                    Your Dashboard
												</DropdownItem>
                                            </a>}
                                            <SignoutButton session={this.props.session} _csrf={this.props._csrf} />
                                            <svg
                                                className="dropdown-arrow-menu"
                                                style={{ right: '75px' }}
                                            >
                                                <path d="M0,10 20,10 10,0z" style={{ fill: '#ffffff' }} />
                                                <path d="M0,10 10,0 20,10" style={{ stroke: '#DBDBDB', fill: 'transparent' }} />
                                            </svg>
                                        </DropdownMenu>
                                    </Dropdown>
                                </Col> :
                                    <Collapse className="navbar-login-item  d-inline-flex nowrap px-0" isOpen={this.state.isOpen} navbar>
                                        <SelectByPlatform>
                                            
                                            <Col className='navbar-submenu-link-login d-flex w-100 navbar-brand-logo' name={"www"}>
                                                <NavbarBrand href="/">
                                                    <SelectByPlatform>
                                                        <GiveIndia name={"www"} width="125" color={!logo || logo === '' || logo === 'color' ? '' : logo} />
                                                        <PartnerLogo name={"wg"} w="100%" className={"partner-logo"} />
                                                    </SelectByPlatform>
                                                </NavbarBrand>
                                            </Col>
                                            <Col md={8} className='navbar-submenu-link-login d-flex w-100 px-0' name={"www"}>
                                            <Fragment>
                                                <NavLink className="user-nav-link" style={{ color: color ? color : "#444444" }} href={`${config.fundraisersPlatformUrl}`} target="_blank">
                                                GiveIndia Fundraisers
                                                </NavLink>

                                                <NavLink className="user-nav-link" style={{ color: color ? color : "#444444" }} href='https://workplace.giveindia.org/' target="_blank">
                                                    Workplace Giving
                                                </NavLink>

                                                {/* <NavLink className="user-nav-link" style={{ color: color ? color : "#444444" }} href={'#'} target="_blank">
                                                    Our Work
                                                </NavLink> */}
                                                
                                                <NavLink className="user-nav-link" style={{ color: color ? color : "#444444" }} href={'/aboutus'} target="_blank">
                                                    About Us
                                                </NavLink>

                                                {/* <Dropdown isOpen={this.state.dropdownOpen} toggle={this.toggle} className="user-nav-link nav-link submenu-dropdown p-0 no-wrap" >
                                                    <DropdownToggle className="gi-h-dropdown" caret style={{ color: color ? color : "#444444" }}>
                                                        Get Involved
                                                        </DropdownToggle>
                                                    <DropdownMenu>
                                                    <NavLink className="user-nav-link" style={{ color: "#444444" }}  href='https://www.giveindia.org/giveassured' target="_blank">
                                                        Corporate Partnerships
                                                    </NavLink>
                                                    <NavLink className="user-nav-link" style={{ color: "#444444" }} rel="noopener noreferrer" target="_blank" href='https://workplace.giveindia.org/'>
                                                        Workplace Giving
                                                    </NavLink>
                                                    </DropdownMenu>
                                                </Dropdown> */}
                                            
                                            </Fragment>
                                    </Col>
                                        <Col md={8} className='navbar-submenu-link-login d-flex w-100 px-0' name={"wg"} ></Col>
                                    </SelectByPlatform>
                                        <LoginMenu
                                            session={session}
                                            toggleLogInModal={toggleLogInModal}
                                            toggleSignUpModal={toggleSignUpModal}
                                            color={color}
                                            width={width}
                                            subdomain={this.props.subdomain}
                                            tenantConfig={this.props.tenantConfig}
                                            _csrf={this.props._csrf}
                                            loginBackgroundColor={loginBackgroundColor}
                                        />
                                    </Collapse>

                                }
                            </div>
                            <Col md={12} className="d-flex flex-wrap px-0 submenu-dropdown" id={`${this.props.stickySecondSubMenu ? 'secondary-menu-sticky' : 'secondary-menu'}`}>
                                <div style={{display:'flex'}} className={`${tenantName === 'AU Bank' ? 'ml-auto' : ''}`}>
                                    <NavbarBrand href="/">
                                        <SelectByPlatform>
                                            <span></span>
                                            <PartnerLogo name={"wg"} w="100%" className={"partner-logo"} />
                                        </SelectByPlatform>
                                    </NavbarBrand>
                                    {hideMainMenu ? null : <RequestInfoContext.Consumer>
                                    {(requestInfo) => {

                                        if (requestInfo.path.match(/^\/flood-relief/)) {
                                            return null;
                                        }
                                        // if (requestInfo.path.match("/program/Mission-No-Child-Homeless") || requestInfo.path.match("/program/Mission-every-girl-in-school")) {
                                        //     return null;
                                        // }
       
                                        return tenantConfig.header && tenantConfig.header.menuLinks.map((menuLink, index) => {
                                            let className = menuLink.className || '';
                                            if (requestInfo.path === menuLink.src) {
                                                className = className + ' active';
                                            }
                                            return (
                                                    <>
                                                    {menuLink.heading === "Missions" ? (
                                                    <Dropdown isOpen={this.state.missionsDropdownOpen} toggle={this.toggleMissions} className="user-nav-link user-dropdown-menu p-0 no-wrap" style={{marginTop:2}} >
                                                        <DropdownToggle className={`gi-h-dropdown h-sub-menu ${color ? "text-white" : "" }`} caret style={{ color , fontSize:16 }}>
                                                            {menuLink.heading}
                                                            </DropdownToggle>
                                                        <DropdownMenu >
                                                        {menuLink.missions && menuLink.missions.map(link =>{
                                                                return <NavLink rel="noopener noreferrer" href={link.src} onClick={() => this.clickMission(link)}>
                                                                            {link.heading}
                                                                        </NavLink>
                                                        })}
                                                        </DropdownMenu>
                                                    </Dropdown>
                                                    ): 
                                                    <NavLink key={index} className={`navbar-cause-link ${className}`}
                                                        style={color ? { color } : {}}
                                                        onClick={(event) => this.trackCauseClick(event)}
                                                        href={menuLink.src}>
                                                        {menuLink.heading}

                                                    </NavLink>
                                                    }

                                                    </>)
                                            })
                                        }}
                                </RequestInfoContext.Consumer>}
                            </div>

                                {/* <NavItem className="setarch-nav-item hide-for-very-large-screen " style={{ width: "400px" }}>
									{!hideSearch ? <SearchWrapper width={width} /> : null}
								</NavItem> */}
                                {((!hideSearch && subdomain === 'www') || (subdomain !== 'www')) 
                                && <a onClick={(e) => this.toggleSearchBox(e)} className={`search-modal-nav-bar d-flex ${tenantName !== 'AU Bank' ? ' ml-auto' : ''} mr-4 navbar-cause-link nav-link`} style={{ cursor: "pointer" }}>
                                    {!this.state.toggleSearchBox ? <img src={`${config.cdnUrl}/static/icons/search.svg`} className="search-icon" /> : <img src={`${config.cdnUrl}/static/icons/close.svg`} alt='close' style={{ height: '1rem' }} />
                                    }
                                </a>}
                                {this.state.toggleSearchBox && <div md={12} lg={12} className="w-100">
                                    <QuickSearch />
                                </div>}
                            </Col>
                        </Row>
                    </div>
                </MediaQuery>

                <MediaQuery maxWidth={992} device={{ width }}>
                    {session && session.user ?

                        <div className="search-nav-item search-d-flex justify-content-between" style={{width: "100%"}}>
                            <NavbarToggler className="borderless-toggler">
                                <SelectByPlatform>
                                    <GiNavToggler
                                        name={"www"}
                                        logo={logo}
                                        isOpen={this.state.isOpen}
                                    />
                                    <WGNavToggler
                                        name={"wg"}
                                        logo={logo}
                                        isOpen={this.state.isOpen}
                                    />
                                </SelectByPlatform>
                            </NavbarToggler>
                            {subdomain === 'www' && <NavLink style={color ? { color, marginLeft: 'auto' } : { marginLeft: 'auto' }} onClick={this.registerSearchClick} className="search-nav-link">
                                <SearchIcon stroke='#000' strokeWidth="5px" color={logo === 'white' ? '#fff' : "#000"} style={{ width: '20px' }} />
                            </NavLink>}

                            <BurgerNavMenu onNavClick={this.toggleNavbar} isOpen={this.state.isOpen} backgroundColor={backgroundColor} />
                        </div>
                        :
                        <div className="search-nav-item search-d-flex justify-content-between" style={{width: "100%"}}>

                            <NavbarToggler className="borderless-toggler">
                                <SelectByPlatform>
                                    <GiNavToggler
                                        name={"www"}
                                        logo={logo}
                                        isOpen={this.state.isOpen}
                                    />
                                    <WGNavToggler
                                        name={"wg"}
                                        logo={logo}
                                        isOpen={this.state.isOpen}
                                    />
                                </SelectByPlatform>
                            </NavbarToggler>

                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <SelectByPlatform>
                                    <ColorLoginUpButton 
                                        toggleLogInModal={toggleLogInModal}
                                        color={color}
                                        name={"www"}
                                    />
                                    <div name={"wg"} />
                                </SelectByPlatform>
                                <BurgerNavMenu onNavClick={this.toggleNavbar} isOpen={this.state.isOpen} backgroundColor={backgroundColor} />

                            </div>
                        </div>
                    }

                    {!this.props.hideLogin ?
                        (this.state.isOpen ?
                            <React.Fragment>
                                <div className="navbarMenu" isOpen={this.state.isOpen}>
                                    <LoginMenu
                                        session={session}
                                        toggleLogInModal={toggleLogInModal}
                                        toggleSignUpModal={toggleSignUpModal}
                                        width={width}
                                        hideSearch={hideSearch}
                                        registerSearchClick={this.registerSearchClick}
                                        subdomain={this.props.subdomain}
                                        tenantConfig={this.props.tenantConfig}
                                        _csrf={this.props._csrf}
                                        loginBackgroundColor={loginBackgroundColor}
                                    />
                                </div>
                                <style >
                                    {
                                        `
									body {
										overflow: hidden;
									}
								`
                                    }
                                </style>
                            </React.Fragment> : null)
                        :
                        <div />
                    }
                </MediaQuery>
                <style global jsx>
                    {
                        `
						.navbar-right-item {
							cursor: pointer;
						}
						.search-icon{
							position: relative;
							width: 24px;
							height: 24px;
						}

                        .user-nav-link .text-white {color:#ffffff !important;}

						@media (min-width: 992px) {
							.page-header {
								padding : 0;
                            }
							.primary-navbar-submenu {
							padding-top: 0.25rem;
							padding-bottom: 0.25rem;
							}
						}


						@media (max-width: 1299px) {
							.hide-for-very-large-screen {
								display: none;
							}
						}

						@media (min-width: 1300px) {
						.hide-for-above-large-screen{
							display: none !important;
					 }


				 }
				 .partner-logo {
						padding-top: 0.5rem;
						padding-bottom: 0.5rem;
						height: 100%;
						}
				 .wg-header {
				 flex-wrap: wrap;
				 }

				 @media (max-width: 1024px) {
					.navbar-cause-link.hide-for-small-screens{
						display: none !important;
                 }
                 @media (max-width: 992px) {
					.wg-header {
                        min-height: 60px !important;
                    }
			 }
					`
                    }
                </style>
            </Navbar>
        );
    }
}

export default subscribe()(Header);
